
exports.getLatest = (array) => {
  return array.sort((a, b) => a.created_at < b.created_at ? 1 : -1).find(x => x !== undefined)
}

exports.getEarliest = (array) => {
  return array.sort((a, b) => a.created_at > b.created_at ? 1 : -1).find(x => x !== undefined)
}